import React, { useState } from 'react'
import 'react-toastify/dist/ReactToastify.css';

import '../../assets/css/login.css';
require('../../assets/css/main.css');
var config = require('../../config/config.json');

export default function ThankYou(props) {
    document.title = props.title
    const LogoURL = require(`../../assets/images/${config.logoUrl}`).default;
    return (
        <div class="login-module page-wrapper font-robo">
            <div class="login-box">
                <div class="card card-1 ">
                    <div class="logo-holder">
                        <div class="college-name" ><img src={LogoURL} class='logo-college' alt='' />{config.collegeName} </div>
                        <div class='feedback-title' >Feedback System</div>
                    </div>
                    <div class="card-body card-thankyou">
                        <center style={{marginTop: '30px'}}>
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                                <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1" />
                                <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
                            </svg>
                        </center>
                        <div class='message-submitThankyou'>
                            <h3>Feedback submited successfully.<br />
                                Thank you for your valuable time.</h3>
                            For latest news and events:<br /> <a href={config.CollegeWebsite} target='blank' style={{ fontWeight: 'bold' }}>{config.CollegeWebsite}</a> </div>

                    </div>
                </div>
            </div>
        </div>
    )
}